var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { LoadMeshMessage, MeshLoadedMessage } from "@messages/rendering/RendererMessages";
export class PreloadableMeshProviderBase {
    constructor(meshPath) {
        this.meshPath = meshPath;
    }
    /** returns a clone of the loaded mesh */
    getMesh(connection) {
        return __awaiter(this, void 0, void 0, function* () {
            const loadMessage = new LoadMeshMessage(this.meshPath);
            const msg = yield connection.askByMessageType(loadMessage, MeshLoadedMessage);
            return msg.mesh.clone();
        });
    }
}
